(function(window, angular){'use strict';

var ngModule = angular.module('pp.values.blocked-countries', ['pp.services.core']);

/**
 * @ngdoc service
 * @name blockedCountries
 * @description
 * Address countries (ISO 3166-1 alpha-3) we refuse for KYC and address changes.
 *
 * The lists come from the page config key `pp.values.blocked-countries`, rendered by
 * the backend (partials/headCore.scala.html) from its own policy,
 * `com.lhe.service.kyc.BlockedCountries` and the `kyc.blocked-countries.*` configuration,
 * so a change is normally made in configuration only. The DEFAULT_* lists below mirror
 * the backend's compiled-in defaults and are used only for a key the page config does
 * not carry, so the client-side validation is never silently lost.
 *
 * The reason codes match the suffix of the backend error code
 * `investor.address.blocked-country.<reason>`.
 */

var CONFIG_KEY = 'pp.values.blocked-countries';

var REASON_UNREGISTERED_MARKET = 'unregistered-market';
var REASON_SANCTIONED = 'sanctioned';

// fallbacks mirroring com.lhe.service.kyc.BlockedCountries.defaults
var DEFAULT_UNREGISTERED_MARKETS = ['JPN', 'CAN', 'USA', 'UMI'];
var DEFAULT_SANCTIONED = ['BLR', 'CAF', 'CUB', 'HTI', 'IRN', 'MMR', 'PRK', 'RUS', 'SSD', 'SYR', 'VEN', 'YEM'];

function normalise(countryCode) {
    return (countryCode || '').toString().trim().toUpperCase();
}

// a configured list replaces the fallback entirely (an empty list disables the group);
// only an absent key uses the fallback
function normaliseList(codes, fallback) {
    if (!angular.isArray(codes)) {
        return fallback.slice();
    }
    return codes.map(normalise).filter(function (code) {
        return code.length > 0;
    });
}

ngModule.factory('blockedCountries', ['ppConfig', function (ppConfig) {

    var config = (ppConfig && ppConfig.get(CONFIG_KEY)) || {};

    // countries where our investments are not registered for offer
    var unregisteredMarkets = normaliseList(config.unregisteredMarkets, DEFAULT_UNREGISTERED_MARKETS);

    // countries subject to financial sanctions and related restrictions
    var sanctioned = normaliseList(config.sanctioned, DEFAULT_SANCTIONED);

    return {
        REASON_UNREGISTERED_MARKET: REASON_UNREGISTERED_MARKET,
        REASON_SANCTIONED: REASON_SANCTIONED,
        unregisteredMarkets: unregisteredMarkets,
        sanctioned: sanctioned,
        all: unregisteredMarkets.concat(sanctioned),

        /**
         * @param {string} countryCode ISO 3166-1 alpha-3
         * @returns {string|null} the reason the country is blocked, or null when it is allowed
         */
        reasonFor: function (countryCode) {
            var code = normalise(countryCode);
            if (unregisteredMarkets.indexOf(code) !== -1) {
                return REASON_UNREGISTERED_MARKET;
            }
            if (sanctioned.indexOf(code) !== -1) {
                return REASON_SANCTIONED;
            }
            return null;
        }
    };
}]);
})(window, window.angular);